import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';



@Injectable({
  providedIn: 'root'
})

export class ParameterService {


  constructor(private http: HttpClient) {

  }

  //programme
  fetchDataPrograme(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/programmes'}`);
  }

  addProgramme(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/programme', item);
  }
  editPrograme(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-programme/${id}`, item);
  }

  deleteProgramme(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/programme/${id}`);
  }


  //end


  // Action
  fetchDataAction(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/actions'}`);
  }

  getActivitéHorsPta(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/activites-hors-pta'}`, item);
  }

  getObjectif(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/objectif-specifiques'}`);
  }


  getResultats(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/resultats'}`);
  }



  getActionByProgramme(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/actions-by-programme/${id}`);

  }
  getPdc(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/actualite-pdc'}`);
  }

  getStatsActionByProgramme(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `stats/tep/programme/actions`, item);

  }

  getStatsActiviteByAction(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `stats/tep/action/activites`, item);

  }

  fetchDataSousActivité(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/pta-sousactivite'}`);
  }

  addAction(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/action', item);
  }


  addObjectif(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/objectif-specifique', item);
  }
  addResultat(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/resultats', item);
  }


  editObjectif(item: any, id: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-objectif-specifique/${id}`, item);

  }

  editResultat(item: any, id: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/resultats/${id}`, item);

  }
  addPdc(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/actualite-pdc', item);
  }

  editPdc(item: any, id: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/actualite-pdc/${id}`, item);

  }
  editAction(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-action/${id}`, item);
  }

  deleteAction(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/action/${id}`);
  }


  deleteAHorsPta(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/delete-activite-hors-pta/${id}`);
  }


  deleteObjectif(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/objectif-specifique/${id}`);
  }

  deleteResultat(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/resultats/${id}`);
  }

  deletePdc(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/actualite-pdc/${id}`);
  }

  //end


  // Projet

  fetchDataProgramme(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/programmes'}`);
  }



  fetchRevueBudgetaire(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'params/activite-revu-budgetaire'}`, item);
  }

  getRecommandation(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/recommandations'}`);
  }

  getRecommandationByMission(item: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/recommandations/'}` + item);
  }


  getsuiviRecommadationByRecommdation(item: any): Observable<any> {
    return this.http.get(environment.apiUrl + `params/suivi-recommandations/${item}`);

  }
  getMission(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'params/missions'}`, item);
  }

  getAllMission(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/missions'}`);
  }
  getTypeMission(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/type_mission'}`);
  }
  addMission(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/mission', item);
  }
  updateMission(item: any, id: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-mission/${id}`, item);

  }
  addRecommndation(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/recommandation', item);
  }

  updateRecommndation(item: any, id: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/update-recommandation/' + id, item);
  }


  addSuiviRecommndation(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/suivi-recommandation', item);
  }
  addProjet(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/programme', item);
  }
  editProjet(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-programme/${id}`, item);
  }

  deleteProjet(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/programme/${id}`);
  }

  deleteTache(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/pta-tache/${id}`);
  }

  updateTache(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-pta-tache/` + id, item);
  }
  //end

  //Indicateurs

  fetchDataIndicateur(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/indicateur-resultat'}`);
  }
  fetchDataIndicateurObjectif(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/indicateur-objectif'}`);
  }

  fetchDataIndicateurPerformance(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/indicateur-performance'}`);
  }
  savePlanificationToIndicateur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/valeur-cible ', item);
  }

  updateValeurcibleTorealiser(item: any): Observable<any> {
    return this.http.put(environment.apiUrl + 'operation/update-indicateur ', item);
  }

  // get cible des indicateurs

  getCibleIndicateurs(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/valeurs-cibles'}`);
  }

  getValeurCible(item:any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/valeurs-cibles'}`,item);
  }
  //TODO:revoir le nommage, consultation de quoi?
  getConsultation(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/consult-pdc'}`, item);
  }

  getActionProgramme(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'params/action-by-program'}`, item);
  }
  getDetailPdcAction(pdcRef: string): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/pdc-related-actions/${pdcRef}`);
  }

  //liste des donnees de montants par annee pour les pdc
  getPdcRelatedActions(referencePdc: string): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/pdc-related-actions/${referencePdc}`);

  }//end getPdcRelatedActions

  //end
  addIndicateurs(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/indicateur-resultat', item);
  }


  addIndicateursObjectif(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/indicateur-objectif', item);
  }

  addIndicateursPerformance(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/indicateur-performance', item);
  }

  addHorsActivitePta(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/activite-hors-pta', item);
  }
  editIndicateurs(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/indicateur-resultat/${id}`, item);
  }


  updateHorsActivitePta(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-activite-hors-pta/${id}`, item);
  }
  editIndicateursObjectif(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/indicateur-objectif/${id}`, item);
  }

  editIndicateursPerformance(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/indicateur-performance/${id}`, item);
  }

  deleteIndicateur(reference: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/indicateur-resultat/${reference}`);
  }

  deleteIndicateurObjectif(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/indicateur-objectif/${id}`);
  }

  deleteIndicateurResultat(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/indicateur-resultat/${id}`);
  }

  deleteIndicateurPerformance(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/indicateur-performance/${id}`);
  }
  deleteCibleIndicateur(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/remove-valeur/${id}`);
  }

  updateCible(id: any, item: any): Observable<any> {
    return this.http.put(environment.apiUrl + `operation/update-valeur-cible`, item);
  }



  //end



  fetchDataDirection(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/directions'}`);
  }

  addDirection(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'params/direction', item);
  }

  editDirection(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `params/change-direction/${id}`, item);
  }

  deleteDirection(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `params/direction/${id}`);
  }

  deleteReccomandation(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/remove-recommandation/${id}`);
  }

  deleteCommission(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/remove-mission/${id}`);
  }
  deletesuiviReccomandation(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/remove-suivi/${id}`);
  }
  //

  fetchDataService(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/services'}`);
  }

  addService(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/service', item);
  }
  getStatistiqueprogrammeByDirection(item: any): Observable<any> {

    return this.http.post(environment.apiUrl + 'stats/tep/direction', item);
  }


  getStatistiqueprogrammeByDirectionDocument(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/tep/direction'}`, item, {
      responseType: 'blob'
    });
  }
  getStatistiqueprogrammeByService(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'stats/tep/service', item);
  }

  getStatistiqueprogrammeByServiceDocument(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/tep/service'}`, item, {
      responseType: 'blob'
    });
  }
  editService(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-service/${id}`, item);
  }

  deleteService(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/remove-service/${id}`);
  }

  fetchDataGestionUser(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/nationalities'}`);
  }




  sendFile(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/read-pta-file', item);
  }

  getValidation(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/programmes'}`);
  }

  //Prohragemme


  getProgramme(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/programmes'}`);
  }
  getDetailActivite(pdcRef: string): Observable<any> {
    return this.http.get(environment.apiUrl + `params/activites/${pdcRef}`);
  }

  getDetailPdcActivite(pdcRef: string): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/pdc-related-activities/${pdcRef}`);
  }


  getHistogrammeData(): Observable<any> {
    const requestdata = {

    }
    return this.http.post(environment.apiUrl + 'params/data', requestdata);
  }

  fetchTypeIndicateur(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/type_indicateurs'}`);
  }



  fetchDataRessource(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/ressources'}`);
  }

  addRessource(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/ressource', item);
  }

  editRessource(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-ressource/${id}`, item);
  }

  deleteRessource(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/ressource/${id}`);
  }

  deleteLocalisation(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/localisation-ressource/${id}`);
  }
  fetchDataTypeResource(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/types-ressources'}`);
  }


  // centre
  getacteurs(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/acteurs'}`);
  }

  addActeur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/acteur', item);
  }

  fetchDatacentre(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/centres'}`);
  }

  addCentre(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + 'operation/centre', item);
  }

  editCentre(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-centre/${id}`, item);
  }

  deleteCentre(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/centre/${id}`);
  }
  deleteActeur(id: any): Observable<any> {
    const requestdata = {
      acteur_id: id
    }
    return this.http.post(environment.apiUrl + `operation/remove-acteur`, requestdata);
  }
  fetchDataTypeArrondissement(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/arrondissements'}`);
  }
  editActeur(item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-acteur`, item);
  }

  geListUsers(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'auth/users-liste'}`)
  }


  getParamPdcPoid(id: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/pdc/' + id}`)
  }
  getPta(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/ptas'}`)
  }


  getPdcItems(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/pdcs'}`)
  }

  getStatDashboard(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/statistique-indicateurs'}`);
  }


  getExercice(): Observable<any> {


    return this.http.get(`${environment.apiUrl + 'params/exercices'}`);
  }


  getGroup(): Observable<any> {


    return this.http.get(`${environment.apiUrl + 'params/groupes'}`);
  }

  getStatsDash2(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/statistique-dashboard'}`);
  }


  // getActivité

  getSousActivité(item: any): Observable<any> {


    return this.http.get(`${environment.apiUrl + 'params/exercices'}`);
  }

  //

  getSubstanceMinerales(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/filtre-ressouces'}`, item
    );
  }

  getStatsDepartement(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/departements'}`);
  }

  getCommuneByDepartement(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `params/communes/${id}`);
  }

  getLocalisationByRessource(id: any): Observable<any> {
    const requestData = {
      type_operation: "data"
    }
    return this.http.post(environment.apiUrl + `operation/localisation-by-ressource/${id}`, requestData);
  }

  getArrondissementById(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `params/arrondissements/${id}`);
  }
  getStatutRessource(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/statut-ressources'}`);
  }


  getResultatByProgramme(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/resultats-by-programme/${id}`);
  }
  getObjectifSpecifiqueParProgramme(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/objectifs-by-programme/${id}`);
  }
  saveLocalisation(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/localisation-ressource'}`, item
    );
  }
  UpdateLocalisation(localisationRef: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-localisation-ressource/${localisationRef}`, item);
  }

  // activite to projet


  getActiviteToProjet(item: any): Observable<any> {
    const requestdata = {
      "programme_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/pta-activites-programme'}`, requestdata
    );
  }

  getStatsActiviteByProjet(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/tep/action/activites'}`, item
    );
  }

  getStatsActiviteByProjetDoc(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/tep/action/activites'}`, item, {
      responseType: 'blob'
    });

  }
  saveActiviteToProjet(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-programme'}`, item
    );
  }

  UpdateActiviteToProjet(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-pta-activite/${id}`, item);
  }
  deleteActiviterToProjet(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/pta-activite/${id}`);
  }

  //end


  // sousActiviterToActiviter

  getSousActiviteToActivite(item: any): Observable<any> {
    const requestdata = {
      "pta_activite_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-activite'}`, requestdata
    );
  }

  saveSousActiviteToActivite(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivite'}`, item
    );
  }

  UpdateSousActiviteToActivite(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-pta-sousactivite/${id}`, item);
  }
  deleteSousActiviteToActivite(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/pta-sousactivite/${id}`);
  }
  //end

  //tacheToSousActivite


  getTacheToSousActivite(item: any): Observable<any> {
    const requestdata = {
      "pta_sous_activite_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/pta-taches-activite'}`, requestdata
    );
  }

  saveTacheToSousActivite(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-tache'}`, item
    );
  }

  UpdateTacheToSousActivite(id: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/change-pta-tache/${id}`, item);
  }
  deleteTacheToSousActivite(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/pta-tache/${id}`);
  }
  //end



  // getsosuactivitete to direction

  getSousActiviteToDirection(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-direction'}`, item
    );
  }

  saveSousActiviteDirection(reference: any, item: any): Observable<any> {
    return this.http.post(environment.apiUrl + `operation/update-pta-tache/${reference}`, item);
  }



  // getsousActiveteToProjetByUser
  getSousActiviteToProjet(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-engaged'}`, item
    );
  }


  getSousActiviteToProjetNonEngage(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-notengaged'}`, item
    );
  }
  //end

  // getsousActivitégag"

  getSousActiviteEngager(item: any): Observable<any> {
    const requestdata = {
      "programme_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-programme'}`, requestdata
    );
  }
  //end

  //ordonnancement

  getOrdonnancement(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-ordonnanced'}`, item

    );
  }
  //end
  //getEncaissement

  getEncaissement(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-encaissed'}`, item

    );
  }
  //end
  //

  getNonOrdonnancement(item: any): Observable<any> {


    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-notordonnanced'}`, item

    );
  }

  getDecaissement(item: any): Observable<any> {


    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivites-notencaissed'}`, item

    );
  }
  //end


  //save Ordonnancemnt

  saveActiviteOrdonnacement(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/ordonnancement'}`, item
    );
  }
  saveActiviteEncaissement(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/encaissement'}`, item
    );
  }

  saveDecaissement(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/decaissement'}`, item
    );
  }

  saveEngagement(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/engagement'}`, item);
  }

  //
  getTache(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/pta-taches'}`);
  }//end getTache

  //liste des taches par sous activite
  getTacheListBySousActiviteItem(sousActiviteId: string,direction_id:any): Observable<any> {
    let item: any = {
       pta_activite_id: sousActiviteId,
       direction_ref:direction_id

     };
    return this.http.post(`${environment.apiUrl + 'operation/pta-taches-activite'}`, item);
  }//end getTacheListBySousActiviteItem


  //statistique

  getStatsProjet(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/programme'}`
    );
  }

  getProjetByUser(item: any): Observable<any> {
    const requestdata = {
      "user_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/user-projects'}`, requestdata
    );
  }

  getPtaActivite(item: any): Observable<any> {
    const requestdata = {
      "programme_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/pta-activite-programme'}`, requestdata
    );
  }


  getPtaTacheProjet(item: any): Observable<any> {
    const requestdata = {
      "programme_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/pta-taches-programme'}`, requestdata
    );
  }

  getPtaSousactivite(item: any): Observable<any> {
    const requestdata = {
      "programme_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/pta-sousactivite-programme'}`, requestdata
    );
  }

  saveTacheToProjet(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/programme-directions'}`, item
    );
  }
  //end


  getDirection(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/directions-programmes'}`);
  }


  deleteProjetToDirection(id: any): Observable<any> {
    const request = {
      "reference": id
    }
    return this.http.post(environment.apiUrl + `operation/remove-direction-programmes`, request);
  }


  // annulation de l'engagement
  annulationEngagement(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/engagement/${id}`);
  }
  // end

  // annulation de l'ordonnancement
  annulationOrdonnancement(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/ordonnancement/${id}`);
  }
  // end annulationOrdonnancement
  annulationEncaissement(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `operation/encaissement/${id}`);
  }

  // tache  realiser a realiser en retard
  getTacheArealiser(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-taches-to-achieve'}`, item
    );
  }// end getTacheArealiser

  //liste des projets utilisateurs
  getListUserProjects(reference: any): Observable<any> {

    return this.http.get(`${environment.apiUrl + 'operation/user/' + reference + '/programmes'}`,
    );
  }// end getListUserProjects

  //liste projets par direction
  getProjetByDirection(item: any): Observable<any> {
    const requestdata = {
      "direction_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/programmes-direction'}`, requestdata
    );
  } //end getProjetByDirection

  //liste directions par projet
  getDirectionsByProjet(item: any): Observable<any> {
    const requestdata = {
      "programme_id": item
    }
    return this.http.post(`${environment.apiUrl + 'operation/directions-programme'}`, requestdata
    );
  } //end getDirectionsByProjet

  // gettache to projet to direction to exercice
  getTacheArealiserRealiserEnRetard(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/programmes-direction'}`, item);
  }

  //statistiques budgetaire
  getStatistiqueTepActiviteBudgetaire(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_ref": userRef }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_ref": userRef }
    }

    let payload = requestData;

    return this.http.post(`${environment.apiUrl + 'operation/tep-activite-budgetaire'}`, payload);
  }//end getStatistiqueTepActiviteBudgetaire

  //get statistiques tep operationnelle
  getStatistiqueTepProjet(item: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = { "annee": item, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_reference": userRef };
    return this.http.post(`${environment.apiUrl + 'stats/tep/programmes'}`, requestData);
  }



  getStatistiquePtaByPeriode(item: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = { "annee": item, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_reference": userRef };
    return this.http.post(`${environment.apiUrl + 'stats/pta/by-periode'}`, requestData);
  }
  //get statistiques tep operationnelle
  getStatistiqueTepOperationnelle(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_ref": userRef }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_ref": userRef }
    }

    return this.http.post(`${environment.apiUrl + 'operation/tep-activite-operationnelle'}`, requestData);
  }//end getStatistiqueTepOperationnelle

  getStatistiqueTepGlobalObgrm(item: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = {};
    requestData = { "annee": item, "date_debut": dateDebut, "date_fin": dateFin, "user_ref": userRef }
    return this.http.post(`${environment.apiUrl + 'operation/montants-programmes'}`, requestData);
  }



  getStatistiqueTepBilanPta(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_ref": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_ref": userRef }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_ref": userRef }
    }

    return this.http.post(`${environment.apiUrl + 'operation/bilan-financier-programmes'}`, requestData);
  }

  getStatistiqueProgrammeProjet(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_reference": userRef }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_reference": userRef }
    }

    return this.http.post(`${environment.apiUrl + 'operation/tep-programmes-direction'}`, requestData);
  }

  getStatistiqueProgrammeProjetPrint(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, userRef: string, type: any): Observable<any> {
    let requestData = {};
    requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": type, "user_reference": userRef }
    return this.http.post(`${environment.apiUrl + 'operation/tep-programmes-direction'}`, requestData, {
      responseType: 'blob'
    });
  }
  getTepByMonth(item: any, dateDebut: any, dateFin: any, userRef: string): Observable<any> {
    let requestData = {};
    requestData = { "annee": item, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": "data", "user_ref": userRef }

    return this.http.post(`${environment.apiUrl + 'operation/tep-annuel'}`, requestData);
  }
  getStatistiqueTableauDeBordIndicateur(item:any): Observable<any> {
    
    return this.http.post(`${environment.apiUrl + 'operation/tableau-bord-indicateurs'}`, item);
  }

  //printStatistiqueTepOperationnelleAsPdf
  printStatistiqueTepOperationnelleAsFile(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    }

    return this.http.post(`${environment.apiUrl + 'operation/tep-activite-operationnelle'}`, requestData, {
      responseType: 'blob'
    });
  }//end printStatistiqueTepOperationnelleAsPdf

  //printStatistiqueTepProjetAsFile
  printStatistiqueTepProjetAsFile(item: any, direction: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
    let requestData = {};
    requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_reference": userReference }

    return this.http.post(`${environment.apiUrl + 'stats/tep/programmes'}`, requestData, {
      responseType: 'blob'
    });
  }//end printStatistiqueTepProjetAsFile


  printStatistiquePtaByPeriode(item: any, direction: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
    let requestData = {};
    requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_reference": userReference }

    return this.http.post(`${environment.apiUrl + 'stats/pta/by-periode'}`, requestData, {
      responseType: 'blob'
    });
  }
  printStatistiqueTepGlobalObgrmAsFile(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    }

    return this.http.post(`${environment.apiUrl + 'operation/tep-programmes  '}`, requestData, {
      responseType: 'blob'
    });
  }
  // printStatistiqueMontant(item: any, projet: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
  //   let requestData = {};
  //   if (projet !== null) {
  //     requestData = { "annee": item,   "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
  //   } else {
  //     requestData = { "annee": item, "direction_id":  dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
  //   }

  //   return this.http.post(`${environment.apiUrl + 'operation/montants-projets'}`, requestData, {
  //     responseType: 'blob'
  //   });
  // }

  //end printStatistiqueTepGlobalObgrmAsFile

  printStatistiqueTableauxDeBordAsFile(item: any): Observable<Blob> {
 
    return this.http.post(`${environment.apiUrl + 'operation/tableau-bord-indicateurs'}`, item, {
      responseType: 'blob'
    });
  }//end printStatistiqueTableauxDeBordAsFile

  printStatistiqueBilanAsFile(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_ref": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    }

    return this.http.post(`${environment.apiUrl + 'operation/bilan-financier-programmes'}`, requestData, {
      responseType: 'blob'
    });
  }//end printStatistiqueBilanAsFile

  printStatistiqueRapportPerformanceAsFile(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    }

    return this.http.post(`${environment.apiUrl + 'operation/rapport-performance'}`, requestData, {
      responseType: 'blob'
    });
  }//end printStatistiqueBilanAsFile
  downloadPdf(item: any): Observable<Blob> {
    return this.http.post(`${environment.apiUrl + 'operation/exportation-pdf'}`, item, {
      responseType: 'blob'
    });
  }


  downloadPdfByLocalisationRessource(id: any): Observable<Blob> {
    return this.http.get(environment.apiUrl + `operation/localisation-rapport/${id}`,
      {
        responseType: 'blob'
      }
    );

  }

  //printStatistiqueTepBudgetaireAsFile
  printStatistiqueTepBudgetaireAsFile(item: any, projet: any, direction: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any): Observable<Blob> {
    let requestData = {};
    if (projet !== null) {
      requestData = { "annee": item, "programme_id": projet, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    } else {
      requestData = { "annee": item, "direction_id": direction, "date_debut": dateDebut, "date_fin": dateFin, "type_operation": typeDoc, "user_ref": userReference }
    }

    let payload = requestData;

    return this.http.post(`${environment.apiUrl + 'operation/tep-activite-budgetaire'}`, payload, {
      responseType: 'blob'
    });
  }//end printStatistiqueTepBudgetaireAsFile

  //cancel tache
  annulerTache(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/cancel-pta-tache'}`, item);
  }
  //end


  printStatistiqueTepProjetDetail(item: any, dateDebut: any, dateFin: any, typeDoc: any, userReference: any, data: any): Observable<Blob> {
    let payload = {
      "annee": item,
      "date_debut": dateDebut,
      "date_fin": dateFin,
      "type_operation": typeDoc,
      "user_ref": userReference
    };

    return this.http.post(`${environment.apiUrl + 'operation/tep-details'}`, payload, {
      responseType: 'blob',
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    });
  }//end printStatistiqueTepProjetDetail

  getStatsEnRetard(): Observable<any> {

    return this.http.get(`${environment.apiUrl + 'params/statistique-taches'}`);
  }

  getStatsIndicateur(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/indicateurs'}`);
  }



  getIndicateurCle(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'operation/tep-annuel'}`, item

    );
  }


  getMontantByProjet(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/montants-programmes'}`, item
    );
  }

  printPdc(item: any): Observable<Blob> {
    return this.http.post(`${environment.apiUrl + 'operation/export-pdc'}`, item, {
      responseType: 'blob'
    });
  }

  //impression pdc global
  printPdcGlobal(item: any): Observable<Blob> {
    return this.http.post(`${environment.apiUrl + 'operation/export-pdc-global'}`, item, {
      responseType: 'blob'
    });
  }//end printPdcGlobal


  //
  getStatistiquePtaGlobal(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/ptaglobal'}`, item

    );
  }

  getStatistiquePdc(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/tep/pdc'}`, item);

  }

  getStatistiquePdcEvaluation(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/bilan-pdc'}`, item, {
      responseType: 'blob'
    });
  }

  printPdcdc(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/tep/pdc'}`, item, {
      responseType: 'blob'
    });
  }

  printStatistiqueGlobalPta(item: any): Observable<Blob> {
    return this.http.post(`${environment.apiUrl + 'stats/pta/evaluation'}`, item, {
      responseType: 'blob'
    });
  }

  getStatistiquePtaDetail(item: any): Observable<Blob> {
    return this.http.post(`${environment.apiUrl + 'stats/pta/detaille'}`, item, {
      responseType: 'blob'
    });
  }

  //

  getStatistiquePtaPlanInvestissement(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/pai'}`, item

    );
  }

  getStatistiqueTepProgramePai(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/tep/pai'}`, item

    );
  }

  getStatistiqueTepProgramePaiDoc(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/tep/pai'}`, item, {
      responseType: 'blob'
    });
  }

  getStatistiqueTepProgramePaiDetail(item: any): Observable<Blob> {
    return this.http.post(`${environment.apiUrl + 'stats/tep/pai/detaille'}`, item, {
      responseType: 'blob'
    });
  }

  getStatsPai(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/plan_investissement'}`, item

    );
  }
  getStatsPaiDoc(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/plan_investissement'}`, item, {
      responseType: 'blob'
    });
  }
  getStatistiquePtaPlanInvestissementDoc(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/pai'}`, item, {
      responseType: 'blob'
    });

  }
  getStatistiqueEvaluationPta(item: any): Observable<any> {

    return this.http.post(`${environment.apiUrl + 'stats/pta/evaluation'}`, item

    );
  }

  getStatistiquePtaByDirection(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/pta/tepbydirection'}`, item
    );
  }

  getStatistiquePtaByService(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/pta/tepbyservice'}`, item
    );
  }



  addMotMaire(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'params/maire-config'}`, item);
  }
  addSlide(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'params/slide-config'}`, item);
  }

  updateSlide(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'params/updateslide-config'}`, item);
  }
  deleteSlide(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `params/removeslide-config/${id}`);
  }
  getMotDumaire(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/maire-config'}`);
  }

  getSlideZoneArticle(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/slide-Config'}`);
  }


  getDetailProjetAc(id: any): Observable<any> {
    return this.http.get(environment.apiUrl + `operation/actualite-pdc/${id}`);

  }

  getParamatrageCommune(): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'params/config'}`);
  }

  deleteGestionUser(id: any): Observable<any> {
    return this.http.delete(environment.apiUrl + `auth/remove-user/${id}`);
  }


  configurePdcPoids(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pdc/add-poids'}`, item);
  }


  downloadFicheEngagement(id: any): Observable<Blob> {
    return this.http.get(environment.apiUrl + `operation/download-preuve-engagement/${id}`,
      {
        responseType: 'blob'
      }
    );

  }

  getHistoriqueOrdonnacement(item: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/activites/historique-ordonnancements/' + item}`);
  }


  getHistoriqueDecaissment(item: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/activites/historique-decaissements/'}` + item);
  }


  downloadFicheOrdonnancement(id: any): Observable<Blob> {
    return this.http.get(environment.apiUrl + `operation/download-mandat-ordonnancement/${id}`,
      {
        responseType: 'blob'
      }
    );

  }


  downloadFicheDecaissement(id: any): Observable<Blob> {
    return this.http.get(environment.apiUrl + `operation/download-fichier-decaissement/${id}`,
      {
        responseType: 'blob'
      }
    );

  }


  printStatistiqueHorsPta(): Observable<Blob> {

    return this.http.get(`${environment.apiUrl + 'operation/activites-hors-pta/export-pdf'}`,
      {
        responseType: 'blob'
      }
    );
  }


  printStatistiqueHorsPtaH(item: any): Observable<Blob> {

    return this.http.post(`${environment.apiUrl + 'operation/activites-hors-pta'}`, item,
      {
        responseType: 'blob'
      }
    );
  }



  getTacheByActivite(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/pta-taches-activite'}`, item);
  }

  getDetailTachesByDirection(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/pta/detailtachesbydirection'}`, item);
  }

  getDetailTachesByService(item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'stats/pta/detailtachesbyservice'}`, item);
  }

  getBordereauChapitres(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/chapitres'}`, { params });
  }

  saveBordereauChapitre(item: any, reference?: string): Observable<any> {
    const url = reference
      ? `operation/bordereau-recettes/chapitres/${reference}`
      : 'operation/bordereau-recettes/chapitres';
    return this.http.post(`${environment.apiUrl + url}`, item);
  }

  deleteBordereauChapitre(reference: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl + 'operation/bordereau-recettes/chapitres/' + reference}`);
  }

  getBordereauSousChapitres(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/sous-chapitres'}`, { params });
  }

  saveBordereauSousChapitre(item: any, reference?: string): Observable<any> {
    const url = reference
      ? `operation/bordereau-recettes/sous-chapitres/${reference}`
      : 'operation/bordereau-recettes/sous-chapitres';
    return this.http.post(`${environment.apiUrl + url}`, item);
  }

  deleteBordereauSousChapitre(reference: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl + 'operation/bordereau-recettes/sous-chapitres/' + reference}`);
  }

  getBordereauComptes(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/comptes-budgetaires'}`, { params });
  }

  saveBordereauCompte(item: any, reference?: string): Observable<any> {
    const url = reference
      ? `operation/bordereau-recettes/comptes-budgetaires/${reference}`
      : 'operation/bordereau-recettes/comptes-budgetaires';
    return this.http.post(`${environment.apiUrl + url}`, item);
  }

  deleteBordereauCompte(reference: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl + 'operation/bordereau-recettes/comptes-budgetaires/' + reference}`);
  }

  getBordereauPrevisions(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/previsions'}`, { params });
  }

  saveBordereauPrevision(compteReference: string, item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/bordereau-recettes/previsions/' + compteReference}`, item);
  }

  importBordereauPrevisions(file: File, annee: number): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('annee', String(annee));
    return this.http.post(`${environment.apiUrl + 'operation/bordereau-recettes/previsions/import'}`, formData);
  }

  getBordereauTitres(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/titres'}`, { params });
  }

  saveBordereauTitre(compteReference: string, item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/bordereau-recettes/titres/' + compteReference}`, item);
  }

  getBordereauRecouvrements(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/recouvrements'}`, { params });
  }

  saveBordereauRecouvrement(titreReference: string, item: any): Observable<any> {
    return this.http.post(`${environment.apiUrl + 'operation/bordereau-recettes/recouvrements/' + titreReference}`, item);
  }

  getBordereauSynthese(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/synthese'}`, { params });
  }

  printBordereauSynthese(params: any): Observable<Blob> {
    return this.http.get(`${environment.apiUrl + 'operation/bordereau-recettes/synthese'}`, {
      params: { ...params, format: 'pdf' },
      responseType: 'blob'
    });
  }
}

